import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Box } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'

const PriceBoxListContainerStyled = styled.div`
  width: 100%;
`

const PriceBoxListItemStyled = styled(Box)`
  width: 100%;
  display: flex;
  height: auto;

  flex-basis: 100%;
  max-width: 100%;

  @media ${media.maxPhone} {
    padding: 0 0 2.1875rem 0;
  }

  @media ${media.phone} {
    padding: 1.375rem;
    flex-basis: 50%;
    max-width: 50%;
  }

  @media ${media.tablet} {
    flex: 1;
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }
  @media ${media.desktop} {
    padding: 2.625rem;
  }
`

const PriceBoxListStyled = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${media.phone} {
    margin: 0 -1.375rem;
  }

  @media ${media.desktop} {
    margin: 0 -2.625rem;
  }

  ${({ isBig, theme }) =>
    isBig &&
    css`
      /* ${PriceBoxListItemStyled} {
        max-width: 20.6875rem;
      } */

      @media ${media.phone} {
        margin: 0 -1rem;
        ${PriceBoxListItemStyled} {
          padding: 1rem;
          flex-basis: 50%;
          max-width: 50%;
        }
      }

      @media ${media.tablet} {
        margin: 0 -1.25rem;
        ${PriceBoxListItemStyled} {
          padding: 1.25rem;
          flex-basis: 33.33333333%;
          max-width: 33.33333333%;
        }
      }
      @media ${media.desktop} {
        margin: 0 -1.25rem;
        ${PriceBoxListItemStyled} {
          padding: 1.25rem;
          flex-basis: 25%;
          max-width: 25%;
        }
      }
    `};
`

export { PriceBoxListContainerStyled, PriceBoxListStyled, PriceBoxListItemStyled }
